import { handleActions } from 'redux-actions';
import { jabraActions } from '../../actions/jabra';
const initialState = {
    meta: {
        list: 'succeeded',
        ring: 'succeeded',
        unring: 'succeeded',
    },
    ui: {
        error: null,
    },
    isConnectedToJabra: false,
    jabraList: [],
};
const { jabraRing, jabraRingSucceeded, jabraRingFailed, jabraUnring, jabraUnringSucceeded, jabraUnringFailed, jabraList, jabraListSucceeded, jabraListFailed, jabraClosed, jabraAttached, jabraDetached, } = jabraActions;
export const jabra = handleActions({
    [jabraRing.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { ring: 'loading' }) });
    },
    [jabraRingSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { ring: 'succeeded' }) });
    },
    [jabraRingFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { ring: 'failed' }) });
    },
    [jabraUnring.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { unring: 'loading' }) });
    },
    [jabraUnringSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { unring: 'succeeded' }) });
    },
    [jabraUnringFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { unring: 'failed' }) });
    },
    [jabraList.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { list: 'loading' }) });
    },
    [jabraListSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { list: 'succeeded' }), ui: {
                error: null,
            }, jabraList: action.payload && action.payload.list ? action.payload.list : [] });
    },
    [jabraListFailed.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { list: 'failed' }), ui: {
                error: action.payload.error,
            }, jabraList: [] });
    },
    [jabraClosed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { jabraList: [] });
    },
    [jabraAttached.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isConnectedToJabra: action.payload && action.payload.connected !== undefined
                ? action.payload.connected
                : state.isConnectedToJabra });
    },
    [jabraDetached.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isConnectedToJabra: action.payload && action.payload.connected !== undefined
                ? action.payload.connected
                : state.isConnectedToJabra });
    },
}, initialState);
